import {
    ajax,
    simulateServiceRequest,
    ajaxB,
    request,
    ajaxP,
    ajaxBack
} from '@/utils/request'



// 获取短信验证码
export function appGetCode(data) {
    return simulateServiceRequest({
        url: 'api/v1/checkCode',
        method: "post",
        params: data
    }, true)
}

// 登录
export function appLogin(data) {
    return simulateServiceRequest({
        url: 'api/v1/checkCode/authenticate',
        method: 'Post',
        data: data
    })
}

// 检查用户是否已经设置密码
export function checkPassword(data) {
    return simulateServiceRequest({
        url: 'api/v1/users/password/exist',
        method: 'get'
    })
}

// 修改密码
export function uodatePassword(data) {
    return simulateServiceRequest({
        url: 'api/v1/users/password/reset',
        method: 'Post',
        data: data
    })
}

// 设置密码
export function sitePassword(data) {
    return simulateServiceRequest({
        url: 'api/v1/users/password',
        method: 'Post',
        data: data
    })
}

// 获取短信验证码
export function getCode(data) {
    return ajaxB('api/v1/customers/h5/checkCode', data, true)
}

// 退出登录
export function loginOut(data) {
    return ajax('api/v1/customers/h5/exit', data, false, true)
}
// 获取我的订单列表
export function getOrderList(data = {}) {
    return ajaxBack({
        url: 'api/v1/orders/h5/page',
        method: "post",
        data: data
    })
}
// 获取车主电子券列表
export function couponsList() {
    return ajaxBack({
        url: 'api/v1/elecTickets/h5/list',
        method: "get"
    })
}
// 使用电子券优惠券
export function useNewCoupons(id) {
    return ajaxP(`api/v1/elecTickets/h5/coupon/exchange/${id}`)
}

// 获取车主卡券列表
export function getCouponsList(data = {}) {
    return ajaxBack({
        url: 'api/v1/coupondetails/getListByCustomerTelephone',
        method: "get",
        params: data
    })
}

// 获取加油券列表
export function getGasCouponsList(data = {}) {
    return ajaxBack({
        url: 'api/v1/redeemCode/findRedeemCodeInfo',
        method: "get",
        params: data
    })
}

// 使用车主卡券
export function useCoupons(data) {
    return ajax(`api/v1/coupondetails/exchangeCoupon/${data.customerId}/${data.couponDetailId}`)
}
// 兑换车主劵
export function exchangeCoupons(data) {
    return ajaxP(`api/v1/orders/h5/redeemCode`, data)
}

// 获取我的订单统计
export function getOrderCount() {
    return ajax('api/v1/orders/h5/count')
}
// 获取最新用户信息
export function getUser() {
    return ajax('api/v1/customers/h5', {
        isNomask: true
    })
}

// 获取用户某个月的车主币支出收入统计
export function getCouponsMonthCount(data) {
    return ajax('api/v1/customers/points/log/h5/total', data)
}
// 获取用户某个月的车主币支出收入列表
export function getCouponsMonthList(data = {}) {
    return ajaxBack({
        url: 'api/v1/customers/points/log/h5/list',
        method: "get",
        params: data
    })
}

// 获取用户openid
export function getOpenid(data) {
    return ajaxP('api/v1/customers/h5/vx/openid', data)
}

// 根据openid登录
export function loginByOpenid(data) {
    return request({
        url: 'api/v1/customers/h5/login/silent',
        method: 'Post',
        params: data
    }, false, true)
}

// 登录
export function login(data) {
    return request({
        url: 'api/v1/customers/h5/login',
        method: 'Post',
        params: data
    })
}

// 获取微信配置
export function getWxConfig(data) {
    return ajax('api/v1/customers/h5/vx/jssdk', data)
}

// 更新用户头像
export function upImg(data) {
    return ajaxP('api/v1/customers/h5/headImage', data, true)
}

// 获取用户默认地址
export function address(data) {
    return ajax('api/v1/customers/address/h5/default')
}

// 获取收货地址列表
export function addressList() {
    return ajax('api/v1/customers/address/h5/list')
}

// 获取收货地址列表
export function addressEdit(data) {
    return ajaxP('api/v1/customers/address/h5', data)
}

// 获取收货地址详情
export function addressInfo(id) {
    return ajax(`api/v1/customers/address/h5/${id}`)
}

// 删除收货地址
export function addressDel(id) {
    return request({
        url: `api/v1/customers/address/h5/${id}`,
        method: 'Delete'
    }, true)
}

// 激活车主卡
export function activationOwner(data) {
    return ajaxP('api/v1/h5/customerCards/activity', data, true)
}

// 兑换车主卡
export function exchangeOwner(id) {
    return ajaxP(`api/v1/h5/customerCards/${id}`)
}

// 车主卡列表
export function ownerList(data) {
    return ajaxBack({
        url: 'api/v1/customers/customerCards',
        method: "get",
        params: data
    })
}
